import PayoffInputForm from "./PayoffInputForm";

export default PayoffInputForm;
